class DeferredEmbed extends HTMLElement {
  constructor() {
    super()
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      root: document.querySelector('#scrollArea'),
      rootMargin: '20% 0px',
      threshold: 0.2,
    })

    this.observer.observe(this)
  }

  handleIntersect(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.loadContent()
      }
    })
  }

  loadContent() {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div')
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(true)
      )

      this.setAttribute('loaded', true)
      const deferredElement = this.appendChild(content.firstChild)

      this.dispatchEvent(
        new CustomEvent('deffered-embed:loaded', {
          bubbles: true,
          composed: true,
          detail: {
            id: this.getAttribute('section-id'),
          },
        })
      )
    }
  }
}

customElements.define('deferred-embed', DeferredEmbed)
